import React from 'react';

const LoadingView = () => {
    return (
        <h1>Load</h1>
    );
};

export default LoadingView;